import type { FC } from 'react';

import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';

interface Props {
  href: string;
  linkTextPrefix: string;
  registerNavn: string;
  forkortelse?: string;
}

export const RegisterLink: FC<Props> = ({ href, linkTextPrefix, registerNavn, forkortelse }) => {
  if (href) {
    const registerText: string = forkortelse ? forkortelse : registerNavn;

    return (
      <div>
        <AnchorLink href={href} target="_blank">{`${linkTextPrefix} ${registerText}`}</AnchorLink>
      </div>
    );
  } else {
    return null;
  }
};
